import { useToast } from "contexts/toast";
import { useState } from "react";

export function usePackageItemNegotiationState (
  requestAcceptItem: (item: { _id: string }, price: number) => any | Promise<any>,
  requestRejectItem: (item: { _id: string }) => any | Promise<any>
) {
  const [acceptingItemIdsList, setAcceptingItemIdsList] = useState<string[]>([]);
  const [rejectingItemIdsList, setRejectingItemIdsList] = useState<string[]>([]);
  const [acceptedItemIdsList, setAcceptedItemIdsList] = useState<string[]>([]);
  const [rejectedItemIdsList, setRejectedItemIdsList] = useState<string[]>([]);
  const [changedPricesMap, setChangedPricesMap] = useState<Record<string, number>>({});

  const toast = useToast();

  const rejectItem = async (item: { _id: string }) => {
    setRejectingItemIdsList(list => [...list, item._id]);
    try {
      await requestRejectItem(item);
      setRejectedItemIdsList(list => [...list, item._id]);
      setRejectingItemIdsList(list => list.filter(_id => _id !== item._id));
    } catch (e) {
      toast?.show({ severity: "error", detail: "There was an error rejecting this item", life: 3000 });
      setRejectingItemIdsList(list => list.filter(_id => _id !== item._id));
    }
  }

  const acceptItem = async (item: { _id: string }, price: number) => {
    setAcceptingItemIdsList(list => [...list, item._id]);
    try {
      await requestAcceptItem(item, price);
      setAcceptedItemIdsList(list => [...list, item._id]);
      setAcceptingItemIdsList(list => list.filter(_id => _id !== item._id));
    } catch (e) {
      toast?.show({ severity: "error", detail: "There was an error accepting this item", life: 3000 });
      setAcceptingItemIdsList(list => list.filter(_id => _id !== item._id));
    }
  }

  const changePriceOfItem = (item: { _id: string }, price: number) => {
    setChangedPricesMap(v => ({ ...v, [item._id]: price }))
  }

  return {
    acceptItem,
    rejectItem,
    changePriceOfItem,
    getStatusById (id: string) {
      return {
        accepting: acceptingItemIdsList.includes(id),
        rejecting: rejectingItemIdsList.includes(id),
        accepted: acceptedItemIdsList.includes(id),
        rejected: rejectedItemIdsList.includes(id),
      }
    },
    getChangedPriceById: (id: string) => {
      return changedPricesMap[id] || null;
    },
    acceptingItemIdsList,
    acceptedItemIdsList,
    rejectingItemIdsList,
    rejectedItemIdsList
  }
}